import {
  Box,
  Flex,
  Text,
  Link,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  useDisclosure,
  Heading,
} from "@chakra-ui/react";
import React from "react";
import { HashLink } from "react-router-hash-link";
import { HamburgerIcon } from "@chakra-ui/icons";

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  const openGoggleDrive = () => {
    setTimeout(() => {
      window.open(
        "https://drive.google.com/file/d/14eP5hBhem8akKlTucxmChlMECWadIu39/view?usp=sharing"
      );
    }, 1500);
  };

  return (
    <Box>
      <Flex
        position="fixed"
        w="100%"
        zIndex="500"
        align="center"
        h={{ lg: "60px", md: "55px", sm: "40px" }}
        bgColor="teal.500"
        // textShadow="0.8px 1px #66b2b2"
        boxShadow="#008080 0px 25px 20px -20px"
      >
        <Text
          ml="20px"
          fontWeight="bold"
          w="70%"
          color="#fff"
          fontSize={{ lg: "20px", md: "16px", sm: "11px" }}
        >
          {`< Faizal Siddiqui />`}
        </Text>
        <Box
          w="100%"
          display={{ lg: "none", md: "none", sm: "block" }}
          position="relative"
        >
          <Flex
            // border="1px"
            // borderColor="red"
            alignSelf="center"
            position="absolute"
            top="-9px"
            right="14px"
          >
            <HamburgerIcon
              cursor="pointer"
              color="#fff"
              onClick={() => onOpen()}
            />
          </Flex>
        </Box>
        <Box w="100%" display={{ lg: "block", md: "block", sm: "none" }}>
          <Flex w="100%" align="center" justify="space-around">
            {NAVBAR.map((el) => (
              <HashLink
                to={el.link}
                key={el.id}
                smooth
                scroll={(el) => scrollWithOffset(el)}
              >
                <Text
                  borderBottom="2px"
                  borderColor="teal.500"
                  _hover={{ borderColor: "#fff" }}
                  cursor="pointer"
                  color="#fff"
                  fontWeight="bold"
                  fontSize={{ lg: "20px", md: "16px", sm: "11px" }}
                >
                  {el.label}
                </Text>
              </HashLink>
            ))}

            <Link
              _hover={{ textDecoration: "none" }}
              href="fw21_0183-Faizal-Siddiqui-Resume.pdf"
              download={true}
            >
              <Text
                onClick={openGoggleDrive}
                borderBottom="2px"
                borderColor="teal.500"
                _hover={{ borderColor: "#fff" }}
                cursor="pointer"
                color="#fff"
                fontWeight="bold"
                fontSize={{ lg: "20px", md: "16px", sm: "11px" }}
              >
                Resume
              </Text>
            </Link>
          </Flex>
        </Box>
      </Flex>

      <Drawer onClose={onClose} isOpen={isOpen} size={"xs"}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton cursor="pointer" color="#fff" />
          <DrawerBody bgColor={"teal.500"}>
            <Flex
              // w="100%"
              align="center"
              justify="space-around"
              flexDir="column"
            >
              {NAVBAR.map((el) => (
                <HashLink
                  to={el.link}
                  key={el.id}
                  scroll={(el) => scrollWithOffset(el)}
                >
                  <Text
                    onClick={onClose}
                    mt="30px"
                    borderBottom="2px"
                    borderColor="teal.500"
                    _hover={{ borderColor: "#fff" }}
                    cursor="pointer"
                    color="#fff"
                    fontWeight="bold"
                    // fontSize={{ lg: "20px", md: "16px", sm: "11px" }}
                  >
                    {el.label}
                  </Text>
                </HashLink>
              ))}

              <Link
                _hover={{ textDecoration: "none" }}
                href="Faizal-Siddiqui-Resume.pdf"
                download={true}
              >
                <Text
                  onClick={openGoggleDrive}
                  mt="30px"
                  borderBottom="2px"
                  borderColor="teal.500"
                  _hover={{ borderColor: "#fff" }}
                  cursor="pointer"
                  color="#fff"
                  fontWeight="bold"
                >
                  Resume
                </Text>
              </Link>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

const NAVBAR = [
  {
    id: 1,
    label: "Home",
    link: "#Home",
  },
  {
    id: 2,
    label: "About",
    link: "#About",
  },
  {
    id: 3,
    label: "Skills",
    link: "#Skills",
  },
  {
    id: 4,
    label: "Project",
    link: "#Projects",
  },
  {
    id: 5,
    label: "Contact",
    link: "#Contact",
  },
];

export default Navbar;
